import * as Mamba from '@mamba/clients';
import { message } from 'ant-design-vue';
import lodash from 'lodash';
import NProgress from 'nprogress';
import Vue from 'vue';
import { $AppConfig } from './global';
import microApp from './microApp';
if (microApp.isMicro) {
    // 设置默认的 AjaxBasics 配置
    Mamba.AjaxBasics.resetDefault({
        target: new URL(window.__MICRO_APP_PUBLIC_PATH__).origin,
        headers: {},
    });
}
Mamba.AjaxBasics.onStart = (AjaxConfig) => {
    if ($AppConfig.ChildrenPage)
        return;
    if (lodash.defaultTo(AjaxConfig.loading, true)) {
        NProgress.start();
    }
};
Mamba.AjaxBasics.onEndAll = NProgress.done;
Mamba.AjaxBasics.onError = function (error, AjaxConfig) {
    // 退出登录
    if (lodash.includes([401], lodash.get(error, 'status'))) {
        window.$nuxt.error(error);
        return Vue.$onLoginOut();
    }
    if (lodash.eq(error.responseType, 'blob')) {
        let reader = new FileReader();
        reader.onload = () => {
            let content = String(reader.result);
            message.error(lodash.get(JSON.parse(content), 'msg'));
        };
        reader.readAsText(error.response);
        return;
    }
    if (lodash.eq(error.message, 'ajax timeout')) {
        error.message = '网络开小差了,请稍后再试~';
    }
    const msg = lodash.find(lodash.compact([
        lodash.get(error, 'message'),
        lodash.get(error, 'msg'),
        '网络开小差了,请稍后再试~',
    ]), lodash.isString);
    message.error({
        key: msg,
        content: msg,
    });
};
lodash.set(Vue, '$Mamba', Mamba);
lodash.set(Vue, 'BasesController', Mamba.BasesController);
lodash.set(Vue, 'BasesDetails', Mamba.BasesDetails);
lodash.set(Vue, 'BasesPagination', Mamba.BasesPagination);
lodash.set(Vue, 'BaseModel', Mamba.BaseModel);
Object.defineProperty(Vue.prototype, '$Mamba', {
    get: lodash.constant(Mamba),
});
